import { render, staticRenderFns } from "./ElementDatesTableColumn.vue?vue&type=template&id=7d312e9a&scoped=true"
import script from "./ElementDatesTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementDatesTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementDatesTableColumn.vue?vue&type=style&index=0&id=7d312e9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d312e9a",
  null
  
)

export default component.exports